import { render, staticRenderFns } from "./GrowerDependantsTab.vue?vue&type=template&id=d5833c34&scoped=true&"
import script from "./GrowerDependantsTab.vue?vue&type=script&lang=js&"
export * from "./GrowerDependantsTab.vue?vue&type=script&lang=js&"
import style0 from "./GrowerDependantsTab.vue?vue&type=style&index=0&id=d5833c34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5833c34",
  null
  
)

export default component.exports